export const INITIAL_PATH = 'initialPath';
